import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseCompetitors() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      competitorID: isEmpty(state.competitorID),
      url: isEmpty(state.url),
    };

    setter(errorState);

    if (errorState.competitorID || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات رقیب را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getCompetitorList = (myPC, searchColumn, search, callback, bool) => {
    let newMypc = myPC;
    if (searchColumn || searchColumn == "") {
      newMypc.searchColumn = searchColumn;
    }
    MyAxios.get(`Admin_ProductCompetitors?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: newMypc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        response.data.resault.products.map((model) => {
          model.id = model.productID;
          return model;
        });
        callback(response.data.resault);
      }
    });
  };

  const getCompetitorDataList = (callback) => {
    MyAxios.get(`Admin_Competitors?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getCompetitorDataListById = (id, callback) => {
    MyAxios.get(`Admin_ProductCompetitors/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getCompetitorByID = (id, callback) => {
    MyAxios.get(`Admin_ProductCompetitors/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateCompetitor = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_ProductCompetitors`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addCompetitor = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ProductCompetitors`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const updatecost = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Competitors/updatecost`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(response.data.message, {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteCompetitor = (id, callback) => {
    const data = new FormData();
    data.append("ProductCompetitorID", id);
    MyAxios.delete(`Admin_ProductCompetitors`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    validate,
    getCompetitorList,
    getCompetitorByID,
    updateCompetitor,
    addCompetitor,
    getCompetitorDataListById,
    getCompetitorDataList,
    deleteCompetitor,
    updatecost,
  };
}
